import React, {
  useState,
} from 'react';

import {
  ArrowLeft,
  ListChecks,
  PlusCircle,
  Trophy,
} from 'lucide-react';

import {
  useNavigate,
} from 'react-router-dom';

import TournamentCreateForm
  from '../components/TournamentCreateForm';

import TournamentList
  from '../components/TournamentList';


type ManagementTab =
  | 'create'
  | 'list';


const formatMonthKey = (
  date: Date,
): string =>
  `${date.getFullYear()}-${String(
    date.getMonth() + 1,
  ).padStart(
    2,
    '0',
  )}`;


const SuperadminTournamentManagePage:
  React.FC = () => {
    const navigate =
      useNavigate();

    const [
      activeTab,
      setActiveTab,
    ] =
      useState<ManagementTab>(
        'create',
      );

    const [
      selectedMonth,
      setSelectedMonth,
    ] =
      useState(
        formatMonthKey(
          new Date(),
        ),
      );


    const handleBack =
      (): void => {
        if (
          window.history.length >
          1
        ) {
          navigate(-1);

          return;
        }

        navigate(
          '/tournaments',
          {
            replace: true,
          },
        );
      };


    const handleTournamentCreated = (
      month: string,
    ): void => {
      setSelectedMonth(
        month,
      );

      setActiveTab(
        'list',
      );
    };


    return (
      <div className="min-h-screen w-full bg-gray-50 px-3 pb-6 pt-14 sm:px-5 md:px-6 md:py-4 lg:px-8">

        <div className="mx-auto w-full max-w-[1440px]">

          <header className="mb-4 flex items-center justify-between gap-3">

            <div className="flex min-w-0 items-center gap-3">

              <button
                type="button"
                onClick={
                  handleBack
                }
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-700 shadow-sm transition hover:bg-gray-100 active:scale-95"
                aria-label="이전 페이지로 돌아가기"
              >
                <ArrowLeft
                  size={21}
                />
              </button>


              <div className="min-w-0">

                <div className="flex items-center gap-1.5 text-main">

                  <Trophy
                    size={17}
                  />

                  <span className="text-xs font-semibold sm:text-sm">
                    Tournament Management
                  </span>

                </div>


                <h1 className="mt-0.5 truncate text-2xl font-bold text-gray-900 sm:text-3xl">
                  대회 관리
                </h1>

              </div>

            </div>

          </header>


          <nav
            className="mb-4 grid grid-cols-2 rounded-2xl border border-gray-200 bg-white p-1.5 shadow-sm"
            aria-label="대회 관리 메뉴"
          >

            <button
              type="button"
              onClick={() =>
                setActiveTab(
                  'create',
                )
              }
              className={`flex items-center justify-center gap-2 rounded-xl px-4 py-3 text-sm font-bold transition ${
                activeTab ===
                'create'
                  ? 'bg-main text-white shadow-sm'
                  : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >

              <PlusCircle
                size={18}
              />

              대회 생성

            </button>


            <button
              type="button"
              onClick={() =>
                setActiveTab(
                  'list',
                )
              }
              className={`flex items-center justify-center gap-2 rounded-xl px-4 py-3 text-sm font-bold transition ${
                activeTab ===
                'list'
                  ? 'bg-main text-white shadow-sm'
                  : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >

              <ListChecks
                size={18}
              />

              대회 목록

            </button>

          </nav>


          {activeTab ===
          'create' ? (

            <TournamentCreateForm
              onCreated={
                handleTournamentCreated
              }
            />

          ) : (

            <TournamentList
              selectedMonth={
                selectedMonth
              }
              onMonthChange={
                setSelectedMonth
              }
            />

          )}

        </div>

      </div>
    );
  };


export default SuperadminTournamentManagePage;